<template>
  <span
    role="button"
    class="copy-table-data"
    @click.prevent="copyVale"
  >
    {{ label }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { QUERIES } from '../config/const';

export default {
  name: "CopyTableData",

  props: {
    default: {
      type: Boolean,
      require: false,
      default: true,
    },
    success: {
      type: String,
      require: false,
      default: "Copied to clipboard",
    },
    label: {
      type: String,
      require: false,
      default: "Copy Grid to Clipboard",
    },
    rows: {
      type: Array,
      required: false,
      default: () => {
        return [
          ["ROW 1", 1, 2, 3, 4],
          ["ROW 2", 1, 2, 3, 4],
          ["ROW 3", 1, 2, 3, 4],
        ];
      },
    },
  },

  computed: {
    ...mapGetters({
      projectCurrency: "projects/projectCurrency",
    }),
  },

  methods: {
    copyVale() {
      let data = ``;

      this.rows.forEach((row, i) => {
        row.forEach((item) => {
          if (i === 0 && item === QUERIES.AVE.LABEL.toUpperCase())
            item += ` (${this.projectCurrency})`;

          data += `${item && typeof item === 'string' ? item.trim().replace(/^[ ]*/gi, '') : item}	`;
        });

        data += `\r`;
      });

      const elem = document.createElement("textarea");
      elem.value = data;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);

      this.$notify({
        group: "store_notifications",
        type: "success",
        text: this.success,
      });
    },
  },
};
</script>

<style scoped>
.copy-table-data {
  cursor: pointer;
}
</style>